import styled, { css, keyframes } from 'styled-components'

const fadeAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
const FadeIn = styled.div`
  height: 100%;
  display: inline-block;
  ${css`
    animation: ${css`
      ${fadeAnimation} 1s linear
    `};
  `}
`

export { FadeIn }
